import type { ReactNode } from 'react';
import './components.css';

interface MetricCardProps {
  label: string;
  value: ReactNode;
  unit?: string;
  delta?: { value: string; positive?: boolean; neutral?: boolean };
  caption?: string;
  /**
   * Optional status colour. Rendered as a small inline dot next to the label
   * - never as a left-border accent, which reads as a templated dashboard.
   */
  status?: string;
}

export function MetricCard({
  label,
  value,
  unit,
  delta,
  caption,
  status,
}: MetricCardProps) {
  return (
    <div className="iris-metric">
      <div className="iris-metric-label">
        {status && (
          <span
            className="iris-metric-dot"
            style={{ background: status }}
            aria-hidden
          />
        )}
        <span>{label}</span>
      </div>
      <div className="iris-metric-value">
        <span className="mono">{value}</span>
        {unit && <span className="iris-metric-unit"> {unit}</span>}
      </div>
      {delta && (
        <div
          className={`iris-metric-delta ${delta.positive ? 'pos' : delta.neutral ? '' : 'neg'}`}
        >
          {delta.value}
        </div>
      )}
      {caption && <div className="iris-metric-caption">{caption}</div>}
    </div>
  );
}
